import React from "react";
import theme from "app/Theme/Theme";
import Svg, { Path } from "react-native-svg";
import normalize from "app/utils/normalize";

const BellIcon = ({
  // !!! pas dans le kitUI avec les icons => pas bien il nous faut une icon reference dans le figma
  height = normalize(24),
  width = normalize(24),
  color = theme.colors["neutral.900"],
  ...props
}) => (
  <Svg
    width={width}
    height={height}
    preserveAspectRatio="xMidYMin meet"
    viewBox="0 0 25 24"
    {...props}
    fill="none"
  >
    <Path
      d="M18.1237 13.992L17.3436 12.6641C17.1798 12.3681 17.0316 11.8081 17.0316 11.4801V9.45608C17.0307 8.56332 16.7833 7.68907 16.3181 6.93448C15.8529 6.1799 15.1889 5.57581 14.4029 5.19212C14.2022 4.82679 13.9096 4.52344 13.5556 4.31375C13.2016 4.10407 12.7991 3.99575 12.3903 4.00013C11.5401 4.00013 10.7756 4.47212 10.37 5.21612C8.84891 5.99211 7.79584 7.6001 7.79584 9.45608V11.4801C7.79584 11.8081 7.64763 12.3681 7.48382 12.6561L6.69597 13.992C6.38395 14.528 6.31375 15.12 6.50876 15.664C6.69597 16.2 7.1406 16.616 7.71784 16.816C9.23113 17.344 10.8224 17.6 12.4137 17.6C14.005 17.6 15.5963 17.344 17.1096 16.824C17.6557 16.64 18.0769 16.216 18.2797 15.664C18.4825 15.112 18.4279 14.504 18.1237 13.992ZM14.6057 18.408C14.4416 18.8737 14.1418 19.2764 13.7468 19.5612C13.3518 19.846 12.881 19.9992 12.3981 20C11.7819 20 11.1735 19.744 10.7444 19.288C10.4948 19.048 10.3076 18.728 10.1984 18.4C10.2998 18.416 10.4012 18.424 10.5104 18.44C10.6898 18.464 10.877 18.488 11.0642 18.504C11.5089 18.544 11.9613 18.568 12.4137 18.568C12.8584 18.568 13.303 18.544 13.7398 18.504C13.9036 18.488 14.0674 18.48 14.2234 18.456L14.6057 18.408Z"
      fill={color}
    />
  </Svg>
);

export default BellIcon;
